// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2G7El","filesListContainer":"PosDisputesFiles_filesListContainer__glC76","filesButton":"PosDisputesFiles_filesButton__sAt4Y"};